export default {
  "common.brand": "USFanslink",
  "nav.home": "Accueil",
  "nav.spreadsheet": "Spreadsheet",
  "nav.creators": "Créateurs",
  "nav.reviews": "Avis",
  "nav.shipping": "Livraison",
  "nav.coupons": "Codes promo",
  "nav.guides": "Guides",
  "nav.shoppingGuide": "Guide d'achat",

  "hero.badge": "Ressources à jour · Informations organisées",
  "hero.title": "USFans Spreadsheet – Explorez créateurs, avis et ressources",
  "hero.subtitle": "Retrouvez des informations utiles sur USFans dans un seul centre de ressources organisé. Explorez le USFans Spreadsheet, l'annuaire des créateurs, les avis, les guides de livraison, les codes promo, les informations d'entrepôt et les dernières actualités.",
  "hero.ctaSpreadsheet": "usfans spreadsheet",
  "hero.ctaBuyNow": "buy it now",
  "hero.dropdownLabel": "Aller vers une catégorie",
  "hero.dropdownPlaceholder": "Choisir une catégorie…",
  "hero.trust": "Ressources à jour • Informations organisées • Axé sécurité • Facile à explorer",

  "categories.title": "Parcourir les catégories populaires",
  "categories.subtitle": "Accédez directement aux produits que vous cherchez sur la boutique du USFans spreadsheet.",

  "categories.shoes": "Chaussures",
  "categories.hoodies": "Sweats/Sweatshirts",
  "categories.tshirts": "T-Shirts",
  "categories.jackets": "Vestes",
  "categories.pants": "Pantalons/Shorts",
  "categories.headwear": "Couvre-chefs",
  "categories.sets": "Ensembles",
  "categories.underwear": "Sous-vêtements",
  "categories.jersey": "Maillots",
  "categories.accessories": "Accessoires",
  "categories.bags": "Sacs",
  "categories.belts": "Ceintures",
  "categories.perfumes": "Parfums",
  "categories.other": "Autres articles",

  "content.eyebrow": "Centre USFans Spreadsheet",
  "content.title": "Qu'est-ce que le USFans Spreadsheet ?",
  "content.p1": "Le USFans Spreadsheet est une ressource unique et organisée qui rassemble les informations liées à USFans au même endroit. Au lieu de chercher sur de nombreuses pages différentes, les visiteurs trouvent créateurs, avis, détails de livraison, codes promo et guides d'entrepôt réunis dans une structure claire et consultable.",
  "content.p2": "Le cœur de ce centre est l'annuaire des créateurs. Chaque créateur est listé avec sa catégorie, les informations disponibles et le statut de sa dernière mise à jour, pour que vous sachiez rapidement qui est actif et quel type de contenu il propose.",
  "content.sub1": "Comment utiliser le spreadsheet",
  "content.p3": "Commencez par choisir une catégorie dans le menu déroulant ci-dessus. Chaque catégorie renvoie vers une section dédiée de la boutique principale, pour que vous accédiez directement aux produits qui vous intéressent — chaussures, maillots, accessoires ou tout autre article du catalogue.",
  "content.sub2": "Avis, livraison et codes promo",
  "content.p4": "Au-delà de l'annuaire, le centre organise aussi des guides pratiques. Lisez les avis pour comprendre la plateforme, vérifiez les frais de livraison avant de commander et cherchez les codes promo et réductions en cours. Tout est réuni pour que vous n'ayez pas à chercher vous-même.",
  "content.sub3": "Sécurité et transparence",
  "content.p5": "Ce site est un centre de ressources indépendant et n'est pas le site officiel d'USFans. Nous veillons à garder les informations organisées et faciles à vérifier, pour que vous puissiez explorer en toute confiance et suivre les liens vers la boutique principale quand vous le souhaitez.",

  "article.ctaTitle": "Envie d'avoir une vue d'ensemble ?",
  "article.ctaText": "Lisez notre guide complet du USFans Spreadsheet pour découvrir en profondeur l'annuaire des créateurs, les avis, la livraison et plus encore.",
  "article.ctaButton": "Lire le guide complet",

  "articles.title": "Guides et articles clés USFans",
  "articles.subtitle": "Des guides indépendants et approfondis sur les avis, la livraison, les codes promo, l'entrepôt, la sécurité et plus encore.",
  "articles.readMore": "Lire le guide",

  "footer.tagline": "Un centre de ressources indépendant pour les informations sur le USFans Spreadsheet.",
  "footer.navTitle": "Explorer",
  "footer.categoriesTitle": "Catégories",
  "footer.disclaimer": "USFanslink est un centre de ressources indépendant et n'est pas affilié au site officiel d'USFans.",
  "footer.rights": "Tous droits réservés."
};